import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const TITLES = {
  almond:  "Том I «Миндаль»",
  medovik: "Медовик как бизнес",
  bento:   "Бенто-торты от А до Я",
  lineart: "Контурные рисунки на бенто",
};

const SUBS = {
  almond:  "Логика вкуса, понимание сочетаний и текстур",
  medovik: "Авторская линейка современных медовиков",
  bento:   "Объёмные рисунки и фигурки из крема",
  lineart: "Стиль line-art, лаконичность и современность",
};

/**
 * Program detail — a warm empty shell reserved for the real landing content
 * (to be transferred separately). Only header + working area, no invented
 * "coming soon" text and no white placeholder cards.
 */
export default function ProgramDetail() {
  const nav = useNavigate();
  const { slug } = useParams();
  const title = TITLES[slug];
  const sub = SUBS[slug];
  if (!title) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-5"
        style={{ background: "linear-gradient(180deg, #F5EAD3 0%, #EFDFC1 100%)" }}
        data-testid="program-detail-notfound"
      >
        <p className="font-serif text-2xl text-[#4A3429]">Программа не найдена</p>
        <button
          onClick={() => nav("/programs")}
          className="mt-6 px-5 py-2 rounded-full bg-[#3E2A1E] text-[#F5EAD3] text-sm"
          data-testid="program-detail-back-notfound"
        >
          К программам
        </button>
      </div>
    );
  }
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ background: "linear-gradient(180deg, #F5EAD3 0%, #EFDFC1 100%)" }}
      data-testid={`program-detail-page-${slug}`}
    >
      <header className="flex items-center gap-3 px-5 md:px-10 pt-5 md:pt-6 pb-3 max-w-5xl mx-auto w-full">
        <button
          onClick={() => nav("/programs")}
          data-testid="program-detail-back-button"
          aria-label="К программам"
          className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-white/70 backdrop-blur border border-[#C9B79A]/50 flex items-center justify-center hover:bg-white transition-colors shadow-[0_2px_10px_rgba(74,59,50,0.10)]"
        >
          <ChevronLeft className="w-5 h-5 text-[#4A3B32]" />
        </button>
      </header>

      <div className="max-w-5xl mx-auto w-full px-5 md:px-10 pt-4 md:pt-8">
        <div
          className="text-[10px] uppercase tracking-[0.28em] text-[#7A5E48]"
          data-testid="program-detail-kicker"
        >
          Программы Anokina Studio
        </div>
        <h1
          className="font-serif text-[#3E2A1E] mt-1 leading-[1.08]"
          style={{ fontSize: "clamp(28px, 3.4vw, 44px)" }}
          data-testid="program-detail-title"
        >
          {title}
        </h1>
        <p
          className="text-[#5C4A3E] mt-3 leading-snug max-w-[640px] text-[15px] md:text-base"
          data-testid="program-detail-subtitle"
        >
          {sub}
        </p>
      </div>

      {/* Reserved working area — intentionally empty until landing content is transferred. */}
      <div
        className="flex-1 max-w-5xl mx-auto w-full px-5 md:px-10 pb-16 pt-8"
        data-testid="program-detail-working-area"
      />
    </div>
  );
}
